import {
  useQuery,
  type QueryClient,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getCustomerCheckoutPricingInfoPath,
  getCustomerCheckoutPricingInfo,
} from '@hungryroot/rest/api/v2/customers/[id]/checkout_pricing_info/get';

type OptionType = Pick<UseQueryOptions, 'enabled'>;

const getQueryKey = () => [
  'CustomerCheckoutPricingInfo',
  getCustomerCheckoutPricingInfoPath(),
];

export async function invalidateCustomerCheckoutPricingInfo(
  client: QueryClient
) {
  await client.invalidateQueries({ queryKey: getQueryKey() });
}

export function useCustomerCheckoutPricingInfo(options?: OptionType) {
  return useQuery({
    queryKey: getQueryKey(),
    queryFn: async () => {
      const resp = await getCustomerCheckoutPricingInfo();

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    enabled: options?.enabled === false ? false : true,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}
